import request from '@/utils/request'


// 
const editBalance = ($param) => {
    return request({
        url: "/api/backend/consignment/editBalance",
        method: "post",
        params: $param,
    })
}

export default {
    editBalance,

}